"use client"

import {
  FunnelChart as RFunnelChart, Funnel, LabelList, Tooltip, ResponsiveContainer,
} from "recharts"
import { type ChartDatum, type ChartDimension, DEFAULT_PALETTE, colorFor } from "./types"
import type { CSSProperties } from "react"

export interface FunnelChartProps {
  data: ChartDatum[]
  /** Field that holds the stage value. */
  valueKey?: string
  /** Field that holds the stage label. */
  nameKey?: string
  palette?: string[]
  colorMap?: Record<string, string>
  /** Render labels on the right side of each band. */
  showLabels?: boolean
  showTooltip?: boolean
  className?: string
  style?: CSSProperties
  height?: ChartDimension
  width?: ChartDimension
}

export function FunnelChart({
  data, valueKey = "value", nameKey = "name",
  palette = DEFAULT_PALETTE, colorMap,
  showLabels = true, showTooltip = true,
  className, style, height = "100%", width = "100%",
}: FunnelChartProps) {
  const decorated = data.map((d, i) => ({ ...d, fill: colorFor(String(d[nameKey] ?? i), i, palette, colorMap) }))
  return (
    <ResponsiveContainer width={width} height={height} className={className} style={style}>
      <RFunnelChart>
        {showTooltip && <Tooltip cursor={{ fill: "hsl(var(--foreground) / 0.06)", stroke: "hsl(var(--muted-foreground))", strokeOpacity: 0.35 }} contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))", borderRadius: 6, fontSize: 11, color: "hsl(var(--card-foreground))" }} />}
        <Funnel dataKey={valueKey} data={decorated} isAnimationActive={false}>
          {showLabels && <LabelList position="right" dataKey={nameKey} stroke="none" fill="currentColor" style={{ fontSize: 11 }} />}
        </Funnel>
      </RFunnelChart>
    </ResponsiveContainer>
  )
}
